import StreetParkingCities from 'feature/street-parking/street-parking-cities/street-parking-cities';

export default StreetParkingCities;
